import * as React from "react";

interface StatisticsGridProps {
  data: {
    label: string;
    value: number;
  }[];
}

export const StatisticsGrid: React.FC<StatisticsGridProps> = ({ data }) => {
  return (
    <dl className="grid grid-cols-1 gap-5 mt-5 sm:grid-cols-3">
      {data.map((datum) => (
        <div key={datum.label} className="px-4 py-5 overflow-hidden bg-white rounded-lg shadow sm:p-6">
          <dt className="text-sm font-medium truncate text-light-900">
            {datum.label}
          </dt>
          <dd className="mt-1 text-3xl font-semibold text-dark-100">
            {datum.value}
          </dd>
        </div>
      ))}
    </dl>
  );
};
